module.exports = __webpack_public_path__ + "static/media/roles.5f87286e.svg";